import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import type { BatchCharacteristicDraft } from "@/types/batch-characteristics.types";

interface ValueListFieldProps {
  values: BatchCharacteristicDraft["values"];
  onChange: (values: BatchCharacteristicDraft["values"]) => void;
}

/**
 * Spec 084 — os valores aceitos de uma característica de lista. Retirar um valor existente não o
 * apaga das bateladas antigas: ele só deixa de ser oferecido para as novas.
 */
export function ValueListField({ values, onChange }: ValueListFieldProps) {
  return (
    <fieldset className="space-y-2">
      <legend className="text-[13px] font-medium text-text-primary">Valores aceitos</legend>
      {values.map((v, i) => (
        <div key={v.id ?? `novo-${i}`} className="flex items-center gap-1.5">
          <Input
            aria-label={`Valor ${i + 1}`}
            placeholder="Ex.: Tipo A"
            value={v.label}
            maxLength={80}
            onChange={(e) =>
              onChange(values.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))
            }
          />
          <Button
            variant="outline"
            size="sm"
            aria-label={`Remover valor ${v.label || i + 1}`}
            onClick={() => onChange(values.filter((_, j) => j !== i))}
          >
            <Trash2 size={14} />
          </Button>
        </div>
      ))}
      <Button variant="outline" size="sm" onClick={() => onChange([...values, { label: "" }])}>
        <Plus size={14} className="mr-1" />
        Novo valor
      </Button>
      <p className="text-[11px] text-text-tertiary">
        Retirar um valor não o apaga das bateladas que já o receberam.
      </p>
    </fieldset>
  );
}
